import type {CallLeg, CallSurfaceView} from './types';

export const isMixable = (leg: CallLeg): boolean => leg.engine === 'sip' || leg.engine === 'matrix';

export interface SurfaceLayout {
    readonly legs: readonly CallLeg[];
    readonly waiting?: {readonly incoming: CallLeg; readonly current: CallLeg};
    readonly many?: readonly CallLeg[];
    readonly held?: CallLeg;
}

export const layoutOf = (view: CallSurfaceView, expanded: boolean): SurfaceLayout => {
    if (view.kind === 'call') {
        return {legs: [view.primary], held: view.held.find(isMixable)};
    }
    if (view.kind !== 'incoming') {
        return {legs: []};
    }
    const mixable = view.incoming.filter(isMixable);
    if (view.current && isMixable(view.current) && mixable.length > 0) {
        return {legs: expanded ? [view.current] : [], waiting: {incoming: mixable[0], current: view.current}};
    }
    if (!view.current && mixable.length > 1) {
        return {legs: [], many: mixable};
    }
    return {legs: view.incoming};
};
